import type { AppManifest } from '@wix/platform-editor-sdk';
import type { TranslationFunction } from 'i18next';

import { shouldEnableUnifiedManager } from '../../../../../utils/experiments';
import { applicationActions } from '../actions';

type ApplicationActions = NonNullable<AppManifest['pages']>['applicationActions'];

export const getApplicationActions = async (t: TranslationFunction): Promise<ApplicationActions> => {
  const actions = [
    ...((await shouldEnableUnifiedManager())
      ? [applicationActions.getUnifiedManagerAction(t)]
      : [applicationActions.getAddPageAction(t)]),
    applicationActions.viewSiteMembersAction,
    applicationActions.getOpenMemberPrivacyDashboardAction(t),
    applicationActions.openSignUpSettingsAction,
    applicationActions.getDeleteMembersAreaAction(t),
  ];

  return { default: actions };
};
